import { ICancellationQuestion } from '../../entitites/cart.entity';
import { QuestionDto } from './question.dto';

export class CancellationQuestionsDto {
  readonly guid: string;
  readonly startedAt: string;
  readonly finalizedAt: string;
  readonly status: string;
  readonly effectiveDate: Date;
  readonly minimumCancellationDate: Date;
  readonly maximumCancellationDate: Date;
  readonly insurance: {
    readonly name: string;
    readonly icon: string;
    readonly date: Date;
  };
  readonly questions: Array<QuestionDto>;

  constructor(params: ICancellationQuestion) {
    this.guid = params.guid;
    this.startedAt = params.started_at;
    this.finalizedAt = params.finalized_at;
    this.status = params.status;
    this.effectiveDate = new Date(params.effective_date);
    this.minimumCancellationDate = new Date(params.minimum_cancellation_date);
    this.maximumCancellationDate = new Date(params.maximum_cancellation_date);
    this.insurance = {
      name: params.insurance.name,
      icon: params.insurance.icon,
      date: new Date(params.insurance.date),
    };
    this.questions = params.questions.map(
      (question) => new QuestionDto(question),
    );
  }
}
